export default {
  name: 'SmartColumnLayout',

  props: {
    columns: {
      type: Number,
      default: (() => 2)
    }
  },

  data() {
    return {};
  },

  computed: {

  },

  methods: {

  },

  mounted() {
    const child_count = this.$refs.columns[0].childElementCount;
    let elements = [...Array(child_count).keys()];
    let assignments = [];
    for (let i = this.columns; i > 0; i--) {
      assignments.push(elements.splice(0, Math.ceil(elements.length / i)));
    }
    for (let i = 0; i < this.columns; i++) {
      for (let j = child_count - 1; j >= 0; j--) {
        if (!assignments[i].includes(j)) {
          this.$refs.columns[i].childNodes[j].remove();
        }
      }
    }
  }

};



// WEBPACK FOOTER //
// ./src/components/Help/SmartColumnLayout/component.js